/*
|--------------------------------------------------------------------------
| Utilities: Tabs
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.utilities.tabs = {
	"init": function(){
		this.bindEvents();
	},
	/**
	 * Bind events for tabs
	 */
	"bindEvents": function(){
		// Highlight active tabs
		$(document).on("click","[data-gh-tabs=true]",function(){
			$(this).parent().find("[data-gh-tabs=true]").addClass("inactive");
			$(this).removeClass("inactive");
		});
	}
};